import { render, staticRenderFns } from "./AppConfigurationList.vue?vue&type=template&id=48c11114&scoped=true&"
import script from "./AppConfigurationList.vue?vue&type=script&lang=js&"
export * from "./AppConfigurationList.vue?vue&type=script&lang=js&"
import style0 from "./AppConfigurationList.vue?vue&type=style&index=0&id=48c11114&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c11114",
  null
  
)

export default component.exports